import React, { Component } from "react";
import PropTypes from "prop-types";
import AboutHeader from "~/scripts/components/AboutHeader";
import ContactsList from "~/scripts/components/ContactsList";
import LocationsList from "~/scripts/components/LocationsList";
import BodyCopy from "~/scripts/components/BodyCopy";
import Social from "~/scripts/components/Social";

class About extends Component {
    static propTypes = {
        onMount: PropTypes.func
    };

    state = {
        loading: false
    };

    async componentDidMount() {
        const { onMount } = this.props;

        if (onMount) {
            onMount();
        }

        this.setState({ loading: true });

        const response = await fetch("/api/about");

        const data = await response.json();

        this.setState({
            loading: false,
            ...data
        });
    }

    render() {
        const {
            bodyCopy,
            contacts,
            headerImage,
            locations,
            socialMediaAccounts
        } = this.state;

        return (
            <div className="page-wrapper">
                <div className="about">
                    <AboutHeader headerImage={headerImage} />
                    <ContactsList contacts={contacts} />
                    <LocationsList locations={locations} />
                    <div className="about__body-copy">
                        <BodyCopy>
                            <div
                                dangerouslySetInnerHTML={{ __html: bodyCopy }}
                            />
                        </BodyCopy>
                    </div>
                    <Social {...socialMediaAccounts} position="left" />
                </div>
            </div>
        );
    }
}

export default About;



// WEBPACK FOOTER //
// ./src/scripts/components/pages/About.js